module.exports = __webpack_public_path__ + "media/app/assets/specializations/mage/arcane-15d634ee5e59fcdc652458aeed6d1918.png";